// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1k84G","icon":"style_icon__Cl1Cx"};